import { createRef } from "react";

import tourOne from "@assets/images/svg/create-shop/tour01.svg";
import tourTwo from "@assets/images/svg/create-shop/tour02.svg";
import tourThree from "@assets/images/svg/create-shop/tour03.svg";
import tourFour from "@assets/images/svg/create-shop/tour04.svg";
import tourFive from "@assets/images/svg/create-shop/tour05.svg";

import tourOneMobile from "@assets/images/create-shop/mobile-step01.png";
import tourTwoMobile from "@assets/images/create-shop/mobile-step02.png";
import tourThreeMobile from "@assets/images/create-shop/mobile-step03.png";
import tourFourMobile from "@assets/images/create-shop/mobile-step04.png";
import tourFourOneMobile from "@assets/images/create-shop/mobile-step04-01.png";
import tourFiveMobile from "@assets/images/create-shop/mobile-step05.png";

export const getCreateShopTourStepsData = ({ isShopLogoAdded, isMobileDevice }) => {
  const step4Image = (() => {
    if (isMobileDevice) return isShopLogoAdded ? tourFourMobile : tourFourOneMobile;
    return tourFour;
  })();

  return {
    step1: {
      id: 1,
      name: "editShopLogo",
      placement: "bottom-end",
      ref: createRef(),
      targetClass: "create-shop-step",
      imgSrc: isMobileDevice ? tourOneMobile : tourOne,
      title: "Add a Logo",
      textData:
        "Easily add a logo by uploading from your device or selecting from previous uploads.",
      showCloseCta: true,
      isResponsiveModal: true,
    },
    step2: {
      id: 2,
      name: "editShopBanner",
      placement: "top-start",
      tooltipOffset: [60, 0],
      ref: createRef(),
      targetClass: "create-shop-step",
      imgSrc: isMobileDevice ? tourTwoMobile : tourTwo,
      title: "Edit and customize your banner",
      textData:
        "Give your shop an instant refresh by editing your banner. You can customize its colors, add text, and more.",
      showCloseCta: true,
      isResponsiveModal: true,
    },
    step3: {
      id: 3,
      name: "editShopCategories",
      placement: "top-start",
      ref: createRef(),
      targetClass: "create-shop-step",
      imgSrc: isMobileDevice ? tourThreeMobile : tourThree,
      title: "Manage Shop Categories",
      textData:
        "You can edit categories, subcategories, and products via your shop catalog after you finish saving your shop.",
      showCloseCta: true,
      isResponsiveModal: true,
    },
    step4: {
      id: 4,
      name: "editSwagLogo",
      placement: "top-start",
      ref: createRef(),
      targetClass: "create-shop-step",
      imgSrc: step4Image,
      title: isShopLogoAdded ? "Edit your swag logo" : "Add swag to your shop",
      textData: isShopLogoAdded
        ? "You can edit the logo that will appear on your swag collection."
        : "Elevate your shop with free branded swag! You can later purchase a full collection of 150+ items from your Shop Dashboard.",
      showCloseCta: true,
      isResponsiveModal: true,
      scrollTop: 300,
    },
    step5: {
      id: 5,
      name: "saveShop",
      placement: "top-start",
      ref: createRef(),
      targetClass: "create-shop-step",
      imgSrc: isMobileDevice ? tourFiveMobile : tourFive,
      title: "Save Your Changes",
      textData:
        "Save to finish creating your shop. Once created, you'll edit your shop via your Shop Dashboard.",
      showCloseCta: true,
      isResponsiveModal: true,
    },
  };
};
